import React from 'react';
import { Outlet } from 'react-router';

/**
 * The address a site's frame opens the Brand Presence issue screen at.
 *
 * It is an entry of its own beside the App's Brand Presence area, never inside it: a site hosts one
 * screen, and the area's navigation leads to screens only the App hosts. It carries no segment the
 * area's address carries either, because every segment of the frame's address becomes a class of its
 * page, and the area's segment lays the page out to fill a frame of fixed height.
 */
export const BRAND_PRESENCE_SITE_ISSUES_PATH = '/brand-presence-issues';

/** Whether a screen is shown in a site's frame, where nothing may lead to a screen only the App hosts. */
export const BrandPresenceSiteFrameContext = React.createContext(false);

/**
 * The frame a site hosts a Brand Presence screen in: the screen alone, without the App area's
 * navigation, in the page's own flow. The site sizes its frame to the height the page reports, so
 * the frame is as tall as what the screen shows and the site's own page scrolls it. The route wraps
 * it in `CmsScreen`, which brings the styles the App's screens are drawn with.
 */
export function BrandPresenceSiteFrame() {
  return (
    <BrandPresenceSiteFrameContext.Provider value={true}>
      <Outlet />
    </BrandPresenceSiteFrameContext.Provider>
  );
}
